/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pricing_PriceInputs */

const en_cp_pricing_price = /** @type {(inputs: Cp_Pricing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDR 299k / team / semester`)
};

const id_cp_pricing_price = /** @type {(inputs: Cp_Pricing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 299 rb / tim / semester`)
};

/**
* | output |
* | --- |
* | "IDR 299k / team / semester" |
*
* @param {Cp_Pricing_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pricing_price = /** @type {((inputs?: Cp_Pricing_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pricing_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pricing_price(inputs)
	return en_cp_pricing_price(inputs)
});